import { cn } from '@/lib/cn';
import { es } from '@/i18n/es';

interface SkeletonProps {
  className?: string;
}

/** Bloque de carga. El contenedor decide la forma. */
export function Skeleton({ className }: SkeletonProps) {
  return (
    <span
      aria-hidden="true"
      className={cn('block overflow-hidden rounded-card bg-surface-alt', className)}
    >
      <span className="block h-full w-full animate-pulse bg-line/40" />
    </span>
  );
}

/** Placeholder de una grilla de portadas, con la misma forma que la real. */
export function StoryCardSkeleton() {
  return (
    <div className="flex flex-col gap-2">
      <Skeleton className="aspect-cover w-full" />
      <Skeleton className="h-4 w-4/5 rounded" />
      <Skeleton className="h-3 w-3/5 rounded" />
    </div>
  );
}

export function StoryGridSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={es.app.loading}
      className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5"
    >
      {Array.from({ length: count }, (_, i) => (
        <StoryCardSkeleton key={i} />
      ))}
    </div>
  );
}

export function TextSkeleton({ lines = 3 }: { lines?: number }) {
  return (
    <div role="status" aria-label={es.app.loading} className="flex flex-col gap-2">
      {Array.from({ length: lines }, (_, i) => (
        <Skeleton key={i} className={cn('h-4 rounded', i === lines - 1 ? 'w-2/3' : 'w-full')} />
      ))}
    </div>
  );
}
